
import {
    Route,
    Switch,
    Redirect
} from "react-router-dom";
import { useSelector } from "react-redux";
import { routes } from "./routes";
import { isRouteAllowedForUser } from "./navigationCommands";
import Chart from 'chart.js/auto'

export const MotoclickRouter = () => {
    const { isSuperAdmin } = useSelector((state) => state.auth);
    return (
        <div>
            <Switch>
                {
                    routes
                    .filter((route) => isRouteAllowedForUser(route, isSuperAdmin))
                    .map(({ to, Component })=>(
                        <Route 
                            key={to}
                            path={to} 
                            component={Component}
                        />
                    ))
                }
                <Redirect to="/panel-lite-legacy"/>
            </Switch>
        </div>
    )
}